// dependancys
import React, { useState, useEffect, useGlobal } from "reactn";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

// hooks
import Loader from "shared-anpost-components/components/loader/Loader";
import GlobalError from "shared-anpost-components/components/globalError/GlobalError";
import loginHooks from "../../../hooks/LoginHooks";
import profileHooks from "../../../hooks/profileHooks";

// Componenets

const LoginFlow = ({ loginCompleteCallback }) => {
    const [loader, setLoader] = useState(true);
    const [ApiError, setApiError] = useState(false); // state to handle API error
    const [loginRequested, setLoginRequested] = useState(false);

    const { setLoginData } = loginHooks();
    const { values } = profileHooks();

    const closeFunc = () => {
        setApiError(false);
    };

    const loginRegCallback = (loginData, callback) => {
        // set login data on the app

        const { data, UID, isVerified, profile} = loginData

        let addresses = [];
        if(data && data.profile) {
            addresses = data.profile.addresses;
        }

        const tempData = {
            ciamUserId: UID,
            loggedIn: true,
            isVerified: true,
            addresses,
            email: profile ? profile.email : ""
        };

        // if this is on the public deliveries page and it's a verified user, redirect the user
        if(window.appMyDeliveriesView === "public" && isVerified) {
            window.location.href = "/myAccount/My-deliveries"
        } else {
            // set logged in state
            setLoginData(tempData);

            // callback for when the current
            loginCompleteCallback(UID, callback);

            setLoader(false);
        }
    };

    const onAppLogin = profileData => {
        const { uid, email, addresses} = profileData;

        const tempData = {
            ciamUserId: uid,
            loggedIn: true,
            isVerified: true,
            addresses,
            email: email || ""
        };

        setLoginData(tempData);
        loginCompleteCallback(uid, null, profileData);
        setLoader(false);
    };

    // called when a registered but not fully logged in

    useEffect(() => {
        window.loggedInUser = window.loggedInUser || {};
        window.loginOverride = window.loginOverride || {};
        window.loggedOutUser = window.loggedOutUser || {};
        window.onMyDeliveriesAppLogin = window.onMyDeliveriesAppLogin || {};

        // callback when a user logs in
        window.loggedInUser.callback = data => {
            if (!loginRequested) {
                setLoginRequested(true);
                setLoader(true);
                loginRegCallback(data);
            }
        };

        // callback for when a user registers
        window.loggedInUser.registerCallback = data => {
            setLoader(true);
            loginRegCallback(data);
        };

        // this is called when the user is unverifieed, first time user
        window.loginOverride.callback = (overrideUID, callback) => {
            if (!loginRequested) {
                setLoginRequested(true);
                setLoader(true);
                const data = {
                    UID: overrideUID
                };
                loginRegCallback(data, callback);
            }
        };

        window.loggedOutUser.callback = () => {
            const data = {
                loggedIn: false
            };
            // set logged in state
            setLoginData(data);
            setLoader(false);
        };

        window.onMyDeliveriesAppLogin.callback = data => {
            setLoginRequested(true);
            onAppLogin(data);
        };

        // if the user is already logged in, hide the loader
        if (values.loggedIn) {
            setLoader(false);
        } 

        // handle for when react script loads later than core / gigya scripts
        // if gigya has loaded and core js has also been initialised, re-run reauthentication to make sure callbacks are sent
        if (window.apgigya && window.gigyaInitStarted && !window.activerUserSessionChecked) {
            window.activerUserSessionChecked = true;
            window.apgigya.checkActiveUserSession();
        }
    }, []);

    return (
        <>
            {ApiError && <GlobalError closeFunc={closeFunc} />}
            {loader && !window.apDevMode && <Loader />}
        </>
    );
};

export default withRouter(LoginFlow);

LoginFlow.propTypes = {
    loginCompleteCallback: PropTypes.func
};
